import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ14({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { referrers } = quizResponses;

  const onAnswer = (answer) => {
    if (referrers.indexOf(answer) !== -1) {
      removeReferrer(answer);
    } else {
      setReferrer(answer);
    }
  };

  const setReferrer = (answer) => {
    setAnswer(ACTIONS.SET_REFERRER, {
      referrer: answer,
    });
  };

  const removeReferrer = (answer) => {
    setAnswer(ACTIONS.REMOVE_REFERRER, {
      referrer: answer,
    });
  };

  const options = [
    {
      title: "Through a friend, family, or co-worker",
    },
    {
      title: "It was gifted to me",
    },
    {
      title: "Through Chic Beauty Box's social media channels",
    },
    {
      title: "I saw an ad on Facebook / Instagram",
    },
    {
      title: "I saw an ad on Pinterest",
    },
    {
      title:
        "Through a blogger, influencer, celebrity, or other social media accounts",
    },
    {
      title: "Through a web search e.g Google",
    },
    {
      title: "I don't remember",
    },
  ];

  const listItems = options.map(({ title }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => {
        onAnswer(title);
      }}
    >
      <div className="custom-control custom-checkbox float-left">
        <input
          type="checkbox"
          id={title}
          name="referrers"
          value={title}
          className="custom-control-input"
          checked={referrers.indexOf(title) !== -1}
          onChange={(e) => {
            if (e.target.checked) {
              removeReferrer(e.target.value);
            } else {
              setReferrer(e.target.value);
            }
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <p className="font-size-h6">{title}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">How did you hear about Chic Beauty Box?</h4>
      <p className="text-muted">Select all that apply</p>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
